import React from "react";

import StyledTooltip from "../../../../../Common/UIComponents/StyledTooltip";
import { isCustomSpecProduct } from "../Helper";

import { ReactComponent as InformationIcon } from "../../../../../../assets/images/product/specmanager/information-line.svg";
import { ReactComponent as ShieldCheckIcon } from "../../../../../../assets/images/product/specmanager/shield-check-line.svg";

const TOOLTIP_STANDARD_COVERAGE = "This product follows the standard spec for this test.";
const TOOLTIP_CUSTOM_COVERAGE = "This product follows the custom spec defined for the specific product.";

const specManagerTooltipContainer = (trigger) => trigger?.closest(".ant-drawer-body") || trigger?.closest(".ant-modal-body") || document.body;

/**
 * Coverage summary for Test Spec (view and add/edit).
 * When `products` is passed, counts are derived from that list (selected / attached products).
 * Otherwise uses numeric props for backward compatibility.
 */
const CoverageSummarySection = ({
  products,
  totalProducts = 0,
  standardProducts = 0,
  customProducts = 0,
}) => {
  const fromProducts = Array.isArray(products);
  const customN = fromProducts
    ? products.filter(isCustomSpecProduct).length
    : customProducts;
  const totalN = fromProducts ? products.length : totalProducts;
  const standardN = fromProducts
    ? Math.max(totalN - customN, 0)
    : standardProducts;

  return (
    <div className="TestSpecOverview__CoverageSection">
      <div className="TestSpecOverview__SectionTitleBar">
        <div className="TestSpecOverview__SectionTitle">Coverage Summary</div>
      </div>

      <div className="TestSpecOverview__CoverageRows">
        <div className="TestSpecOverview__CoverageRow">
          <div className="TestSpecOverview__RowLabel">Total Products</div>
          <div className="TestSpecOverview__Badge TestSpecOverview__Badge--total">
            {totalN}
          </div>
        </div>

        <div className="TestSpecOverview__CoverageRow">
          <div className="TestSpecOverview__RowLabel">Products following standard spec</div>
          <StyledTooltip
            placement="left"
            title={TOOLTIP_STANDARD_COVERAGE}
            className="SpecManagerProductTooltip"
            getPopupContainer={specManagerTooltipContainer}
          >
            <div className="TestSpecOverview__Badge TestSpecOverview__Badge--standard">
              <ShieldCheckIcon className="TestSpecOverview__BadgeIcon" />
              {standardN}
            </div>
          </StyledTooltip>
        </div>

        <div className="TestSpecOverview__CoverageRow">
          <div className="TestSpecOverview__RowLabel">Products following custom spec</div>
          <StyledTooltip
            placement="left"
            title={TOOLTIP_CUSTOM_COVERAGE}
            className="SpecManagerProductTooltip"
            getPopupContainer={specManagerTooltipContainer}
          >
            <div className="TestSpecOverview__Badge TestSpecOverview__Badge--custom">
              <InformationIcon className="TestSpecOverview__BadgeIcon" />
              {customN}
            </div>
          </StyledTooltip>
        </div>
      </div>
    </div>
  );
};

export default CoverageSummarySection;
